import { computed, watch } from "vue"
import { codigo_condominio, tipo_relacao, url_assembleia, url_clube_vantagens } from "../auth"
import router from "~/router/router"
import { useStore } from ".."
import { empresa } from "../empresas"
const store = useStore()



export type Permissions = {
    documentos: 'view' | 'create'
    reservas: 'view' | 'create' | 'checklist' | 'cancel'
    prestadores_de_servico: 'view' | 'create'
    quadro_avisos: 'view' | 'create'
    agenda_sindico: 'view'
    conta_corrente: 'view'
    segunda_via: 'view'
    relatorio_docs: 'view'
    historico_juridico: 'view'
    relatorio_devedores: 'view'
    livro_digital: 'view' | 'approve'
    demonstrativo_financeiro: 'view'
    informe_rendimento: 'view'
    vencimento_ago: 'view'
    leitura_agua: 'view' | 'create'
    leitura_gas: 'view' | 'create'
    autorizacao_pagamento: 'view'
    meus_dados: 'view'
    notificacao_mudanca: 'view' | 'create'
    notificacao_portaria: 'view' | 'create'
    chama_sindico: 'view' | 'create'
    assembleia: 'view' | 'create' | 'vote'
    graficos: 'view'
    contrato_emprestimo: 'view'
    dependentes: 'view' | 'create' | 'delete' | 'change_access'
    solicitacao_pagamento: 'view' | 'authorization' | 'ressarcimento' | 'consult'
    relacao_doc_pago: 'view'
    agencia_virtual: 'contact' | 'manutencao'
    dados_condomino: 'view'
    solicitacao_negativa: 'view'
    atualizacao_doc_linha: 'view'
    consulta_recibo: 'view'
}

export type ControleAcesso = {
    [key in keyof Permissions]: {
        [k in Permissions[key]]: boolean
    }
}

export const controle_acesso = computed<ControleAcesso>(() => {
    const c: ControleAcesso = {
        documentos: {
            view: false,
            create: false
        },
        reservas: {
            view: false,
            create: false,
            checklist: false,
            cancel: false
        },
        prestadores_de_servico: {
            view: false,
            create: false
        },
        quadro_avisos: {
            view: false,
            create: false
        },
        agenda_sindico: {
            view: false
        },
        conta_corrente: {
            view: false
        },
        segunda_via: {
            view: false
        },
        relatorio_docs: {
            view: false
        },
        historico_juridico: {
            view: false
        },
        relatorio_devedores: {
            view: false
        },
        livro_digital: {
            view: false,
            approve: false
        },
        demonstrativo_financeiro: {
            view: false
        },
        informe_rendimento: {
            view: false
        },
        vencimento_ago: {
            view: false
        },
        leitura_agua: {
            view: false,
            create: false
        },
        leitura_gas: {
            view: false,
            create: false
        },
        autorizacao_pagamento: {
            view: false
        },
        meus_dados: {
            view: false
        },
        notificacao_mudanca: {
            view: false,
            create: false
        },
        chama_sindico: {
            view: false,
            create: false
        },
        assembleia: {
            view: false,
            create: false,
            vote: false
        },
        graficos: {
            view: false
        },
        contrato_emprestimo: {
            view: false
        },
        dependentes: {
            view: false,
            create: false,
            delete: false,
            change_access: false
        },
        solicitacao_pagamento: {
            view: false,
            authorization: false,
            ressarcimento: false,
            consult: false
        },
        relacao_doc_pago: {
            view: false
        },
        agencia_virtual: {
            contact: false,
            manutencao: false
        },
        dados_condomino: {
            view: false
        },
        solicitacao_negativa: {
            view: false
        },
        atualizacao_doc_linha: {
            view: false
        },
        consulta_recibo: {
            view: false
        },
        notificacao_portaria: {
            view: false,
            create: false
        }
    }
    return c
})

export function hasPermission<Resource extends keyof Permissions>(
    resource: Resource,
    action: Permissions[Resource],
    tipos_relacao?: string[]
): boolean {

    if (tipos_relacao && tipos_relacao.length > 0 && !tipos_relacao.includes(tipo_relacao.value)) {
        
        return false
    }
    let r = controle_acesso.value[resource]
    let a = r[action]
    return a

    return true
 }

export enum MenuGroup {
    FINANCEIRO = "Financeiro",
    DOCUMENTOS = "Documentos",
    RESERVAS = "Reservas",
    ASSEMBLEIAS = "Assembleias",
    CLUBE_DE_VANTAGENS = "Clube de Vantagens",
    PRESTADORES_DE_SERVICOS = "Prestadores de serviços",
    MURAL = "Mural",
    ADMINISTRACAO_DO_CONDOMINIO = "Administração do condomínio",
    CONTA = "Conta"
}

export function createAcl<Resource extends keyof Permissions>(resource: Resource,
    action: Permissions[Resource]) {
    return {
        resource,
        action
    }
}

export type ACL = ReturnType<typeof createAcl>

export type MenuItem = {
    group: MenuGroup
    name: string
    label: string
    icon: string
    to?: string
    href?: string
    target?: string
    priority?: number
    action?: () => void
    acl?: () => boolean
}


export const menu_items = computed<MenuItem[]>(() => [
    // financeiro
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:leituras',
        label: 'Leituras',
        icon: 'mdi mdi-glasses',
        to: '/financeiro/leituras',
        acl: () => {
            return hasPermission('leitura_agua', 'view') || hasPermission('leitura_gas', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:boletos',
        label: 'Boletos',
        icon: 'mdi mdi-barcode',
        to: '/financeiro/segunda-via',
        priority: 60,
        acl: () => {
            return hasPermission('segunda_via', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:conta-corrente',
        label: 'Conta corrente',
        icon: 'mdi mdi-credit-card-check-outline',
        to: '/financeiro/conta-corrente',
        priority: 20,
        acl: () => {
            return hasPermission('conta_corrente', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:inadimplentes',
        label: 'Inadimplentes',
        icon: 'mdi mdi-currency-usd-off',
        to: '/financeiro/inadimplentes',
        acl: () => {
            return hasPermission('relatorio_devedores', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:relacao-valores',
        label: 'Relação de valores',
        icon: 'mdi mdi-cash-multiple',
        to: '/financeiro/relacao-valores',
        acl: () => {
            return hasPermission('relatorio_docs', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:autorizacao-de-notas',
        label: 'Autorização de NF',
        icon: 'mdi mdi-account-tie',
        to: '/financeiro/autorizacao-notas',
        acl: () => {
            return hasPermission('autorizacao_pagamento', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:solicitacao-de-pagamento',
        label: 'Solicitação de pagamento',
        icon: 'mdi mdi-arrow-collapse',
        to: '/solicitacao-de-pagamento/busca-fornecedor',
        acl: () => {
            return hasPermission('solicitacao_pagamento', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:historico-de-solicitacao-de-pagamento',
        label: 'Histórico de solicitação de pagamento',
        icon: 'mdi mdi-arrow-collapse',
        to: '/solicitacao-de-pagamento/historico',
        acl: () => {
            return hasPermission('solicitacao_pagamento', 'consult')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:adesao-seguro-conteudo',
        label: 'Adesão seguro conteúdo',
        icon: 'mdi mdi-lock-open-check-outline',
        to: '/seguro-conteudo',
        acl: () => {
            return true
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:livro-digital',
        label: 'Livro digital',
        icon: 'mdi mdi-book-open-page-variant-outline',
        to: '/financeiro/livro-digital',
        priority: 40,
        acl: () => {
            return hasPermission('livro_digital', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:historico-juridico',
        label: 'Histórico jurídico',
        icon: 'mdi mdi-scale-balance',
        to: '/financeiro/historico-juridico',
        acl: () => {
            return hasPermission('historico_juridico', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:vencimento-ago',
        label: 'Vencimento AGO',
        icon: 'mdi mdi-calendar-clock-outline',
        to: '/financeiro/vencimento-ago',
        acl: () => {
            return hasPermission('vencimento_ago', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:demonstrativo-financeiro',
        label: 'Demonstrativo financeiro',
        icon: 'mdi mdi-calculator',
        to: '/financeiro/demonstrativo-financeiro',
        priority: 50,
        acl: () => {
            return hasPermission('demonstrativo_financeiro', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:informe-de-rendimentos',
        label: 'Informe de rendimentos',
        icon: 'mdi mdi-chart-histogram',
        to: '/financeiro/informe-rendimentos',
        acl: () => {
            return hasPermission('informe_rendimento', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:consultar-recibos',
        label: 'Consultar recibos',
        icon: 'mdi mdi-account-tie',
        to: '/financeiro/consultar-recibos',
        acl: () => {
            return hasPermission('consulta_recibo', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:graficos',
        label: 'Gráficos',
        icon: 'mdi mdi-finance',
        to: '/financeiro/graficos',
        acl: () => {
            return hasPermission('graficos', 'view')
        }
    },
    {
        group: MenuGroup.FINANCEIRO,
        name: 'financeiro:boletos-pagos',
        label: 'Boletos pagos',
        icon: 'mdi mdi-text-box-check-outline',
        to: '/financeiro/relacao-docs-pagos',
        acl: () => {
            return hasPermission('relacao_doc_pago', 'view')
        }
    },
    // documentos
    {
        group: MenuGroup.DOCUMENTOS,
        name: 'documentos:documentacao-condominal',
        label: 'Documentação condominial',
        icon: 'mdi mdi-file-document-outline',
        to: '/dados-condominos/documentos',
        priority: 70,
        acl: () => {
            return hasPermission('documentos', 'view')
        }
    },
    {
        group: MenuGroup.DOCUMENTOS,
        name: 'documentos:lista-de-condominos',
        label: 'Lista de condôminos',
        icon: 'mdi mdi-format-list-checkbox',
        to: '/dados-condominos/lista-condomino',
        acl: () => {
            return hasPermission('dados_condomino', 'view')
        }
    },
    {
        group: MenuGroup.DOCUMENTOS,
        name: 'documentos:certidao-negativa',
        label: 'Certidão negativa',
        icon: 'mdi mdi-file-document',
        to: '/dados-condominos/certidao-negativa',
        acl: () => {
            return hasPermission('solicitacao_negativa', 'view')
        }
    },
    // reservas
    {
        group: MenuGroup.RESERVAS,
        name: 'reservas:reservar',
        label: 'Reservar',
        icon: 'mdi mdi-update',
        to: '/reservas/reservar',
        priority: 80,
        acl: () => {
            return hasPermission('reservas', 'view')
        }
    },
    {
        group: MenuGroup.RESERVAS,
        name: 'reservas:minhas-reservas',
        label: 'Minhas reservas',
        icon: 'mdi mdi-update',
        to: '/reservas/minhas-reservas',
        acl: () => {
            return hasPermission('reservas', 'view')
        }
    },
    {
        group: MenuGroup.RESERVAS,
        name: 'reservas:datas-bloqueadas',
        label: 'Datas bloqueadas',
        icon: 'mdi mdi-calendar',
        to: '/reservas/datas-bloqueadas',
        acl: () => {
            return hasPermission('reservas', 'view', ['S','T'])
        }
    },
    {
        group: MenuGroup.RESERVAS,
        name: 'reservas:gerenciar-reservas',
        label: 'Gerenciar reservas',
        icon: 'mdi mdi-notebook-edit-outline',
        to: '/reservas/gerenciar-reservas',
        acl: () => {
            return hasPermission('reservas', 'view', ['S'])
        }
    },
    {
        group: MenuGroup.RESERVAS,
        name: 'reservas:cancelamentos',
        label: 'Cancelamentos',
        icon: 'mdi mdi-book-cancel-outline',
        to: '/reservas/reservas-canceladas',
        acl: () => {
            return hasPermission('reservas', 'view', ['S'])
        }
    },
    // assembleias
    {
        group: MenuGroup.ASSEMBLEIAS,
        name: 'assembleias:todas-as-assembleias',
        label: 'Todas as assembleias',
        icon: 'mdi mdi-human-capacity-increase',
        href: url_assembleia.value,
        acl: () => {
            return hasPermission('assembleia', 'view')
        }
    },
    // clube de vantagens
    {
        group: MenuGroup.CLUBE_DE_VANTAGENS,
        name: 'clube-de-vantagens:clube-de-vantagens',
        label: 'Clube Vantagens',
        icon: 'mdi mdi-human-capacity-increase',
        href: url_clube_vantagens.value,
        acl: () => {
            return codigo_condominio.value != 0
        }
    },
    // prestadores de servicos
    {
        group: MenuGroup.PRESTADORES_DE_SERVICOS,
        name: 'prestadores-de-servico:lista-de-prestadores',
        label: 'Lista de prestadores',
        icon: 'mdi mdi-account-group-outline',
        to: '/prestadores',
        acl: () => {
            return hasPermission('prestadores_de_servico', 'view')
        }
    },
    //mural
    {
        group: MenuGroup.MURAL,
        name: 'mural:quadro-de-avisos',
        label: 'Quadro de avisos',
        icon: 'mdi mdi-bulletin-board',
        to: '/mural/quadro-de-avisos',
        priority: 30,
        acl: () => {
            return hasPermission('quadro_avisos', 'view')
        }
    },
    {
        group: MenuGroup.MURAL,
        name: 'mural:chama-o-sindico',
        label: 'Chama o síndico',
        icon: 'mdi mdi-account-search',
        to: '/mural/chama-o-sindico',
        acl: () => {
            return hasPermission('chama_sindico', 'view')
        }
    },
    {
        group: MenuGroup.MURAL,
        name: 'mural:agenda-sindico',
        label: 'Agenda do síndico',
        icon: 'mdi mdi-calendar-star',
        to: '/mural/agenda-sindico',
        acl: () => {
            return hasPermission('agenda_sindico', 'view')
        }
    },
    {
        group: MenuGroup.MURAL,
        name: 'mural:notificacao-de-mudanca',
        label: 'Notificação de Mudança',
        icon: 'mdi mdi-comment-bookmark-outline',
        to: '/mural/notificacao-mudanca',
        acl: () => {
            return hasPermission('notificacao_mudanca', 'view')
        }
    },
    {
        group: MenuGroup.MURAL,
        name: 'mural:notificacao-portaria',
        label: 'Notificação portaria',
        icon: 'mdi mdi-comment-bookmark-outline',
        to: '/mural/notificacao-portaria',
        acl: () => {
            return false
        }
    },
    // administração do condomínios
    {
        group: MenuGroup.ADMINISTRACAO_DO_CONDOMINIO,
        name: 'administracao-do-condominio:dados-do-sindico',
        label: 'Dados do síndico',
        icon: 'mdi mdi-account-tie',
        to: '/administracao-condominio/dados-sindico',
        acl: () => {
            return codigo_condominio.value != 0
        }
    },
    // conta
    {
        group: MenuGroup.CONTA,
        name: 'conta:meu-perfil',
        label: 'Meu perfil',
        icon: 'mdi mdi-account-supervisor',
        to: '/meus-dados',
        acl: () => {
            return true
        }
    },
    {
        group: MenuGroup.CONTA,
        name: 'conta:sistema-antigo',
        label: 'Sistema Antigo',
        icon: 'mdi mdi-restore',
        target: '_blank',
        href: `https://${empresa.domain}/area-do-cliente-antiga`,
        priority: 10,
        acl: () => {
            return true
        }
    },
    {
        group: MenuGroup.CONTA,
        name: 'conta:sair',
        label: 'Sair',
        icon: 'mdi mdi-exit-to-app',
        priority: -10,
        async action() {
            try {
                await Promise.all([
                    store.dispatch("setCliente", {}),
                    store.dispatch("setRelacoes", []),
                    store.dispatch("setRelacaoId", 0),
                    store.dispatch("setCondominioId", 0),
                    store.dispatch("setContratoId", 0),
                    store.dispatch("setImovelId", 0),
                    store.dispatch("setRefreshToken", null),
                    store.dispatch("setJwt", null),
                ]);

                router.replace("/login");
            } catch (error) {
                console.error(error);
            }
        },
        acl: () => {
            return true
        }
    },
])

watch(() => store.getters.controleAcesso, () => {
    if (!store.getters.controleAcesso) {
        return
    }
    const controleAcesso = store.getters.controleAcesso
    controle_acesso.value.leitura_agua.view = controleAcesso.lancamentoLeituraAgua?.acesso || false
    controle_acesso.value.leitura_gas.view = controleAcesso.lancamentoLeituraGas?.acesso || false
    controle_acesso.value.segunda_via.view = controleAcesso.segundaVia?.acesso || false
    controle_acesso.value.conta_corrente.view = controleAcesso.contaCorrente?.acesso || false
    controle_acesso.value.relatorio_devedores.view = controleAcesso.relatorioDevedor?.acesso || false
    controle_acesso.value.relatorio_docs.view = controleAcesso.relatorioDOCs?.acesso || false
    controle_acesso.value.autorizacao_pagamento.view = controleAcesso.autorizacaoPagamento?.acesso || false
    controle_acesso.value.solicitacao_pagamento.view = controleAcesso.solicitacaoPagamento?.acesso || false
    controle_acesso.value.solicitacao_pagamento.consult = controleAcesso.solicitacaoPagamento?.consulta || false
    controle_acesso.value.livro_digital.view = controleAcesso.livroDigital?.acesso || false
    controle_acesso.value.historico_juridico.view = controleAcesso.historicoJuridico?.acesso || false
    controle_acesso.value.vencimento_ago.view = controleAcesso.vencimentoAGO?.acesso || false
    controle_acesso.value.demonstrativo_financeiro.view = controleAcesso.demonstrativoFinanceiro?.acesso || false
    controle_acesso.value.informe_rendimento.view = controleAcesso.informeRendimento?.acesso || false
    controle_acesso.value.consulta_recibo.view = controleAcesso.consultaRecibo?.acesso || false
    controle_acesso.value.graficos.view = controleAcesso.graficos?.acesso || false
    controle_acesso.value.relacao_doc_pago.view = controleAcesso.relacaoDOCPago?.acesso || false
    controle_acesso.value.documentos.view = controleAcesso.documento?.acesso || false
    controle_acesso.value.dados_condomino.view = controleAcesso.dadosCondomino?.acesso || false
    controle_acesso.value.solicitacao_negativa.view = controleAcesso.solicitacaoNegativa?.acesso || false
    controle_acesso.value.reservas.view = controleAcesso.reserva?.acesso || false
    controle_acesso.value.assembleia.view = controleAcesso.assembleia?.acesso || false
    controle_acesso.value.prestadores_de_servico.view = controleAcesso.prestadorServico?.acesso || false
    controle_acesso.value.quadro_avisos.view = controleAcesso.quadroAviso?.acesso || false
    controle_acesso.value.chama_sindico.view = controleAcesso.chamaSindico?.acesso || false
    controle_acesso.value.agenda_sindico.view = controleAcesso.agendaSindico?.acesso || false
    controle_acesso.value.notificacao_mudanca.view = controleAcesso.notificacaoMudanca?.acesso || false
    controle_acesso.value.notificacao_portaria.view = controleAcesso.notificacaoPortaria?.acesso || false
    controle_acesso.value.meus_dados.view = controleAcesso.meusDados?.acesso || false

})